import { Route } from '@angular/router';
import { AppUrls } from '../../../../../common/dto/app-urls';
import { FormsRoute } from './forms/forms.route';

export const FeedbackRoute: Route = {
  path: AppUrls.Dashboard._.Feedback.relativeUrl,
  children: [
    FormsRoute,
    {
      path: '**',
      redirectTo: FormsRoute.path,
    },
  ],
};
